import { ISigningUrls } from "interfaces/i-application-information"
import { IApplicationUrlsDto } from "interfaces/i-signing-urls"

const SigningUrlsMapping: Record<
	keyof ISigningUrls,
	(isCoApplicant: boolean) => keyof IApplicationUrlsDto
> = {
	pnSigning: (isCoApplicant) => (!isCoApplicant ? "applicantSigning" : "coapplicantSigning"),
	onlineIdentification: () => "onlineIdentification",
    psD2: (isCoApplicant) => (!isCoApplicant ? "applicantPsd2" : "coapplicantPsd2"),
	ppiSigning: () => "ppiContract",
	applicantConsent: () => "applicantConsent",
	spouseConsent: () => "spouseConsent",
}

export const getIApplicationUrlsDto = (urlName: keyof ISigningUrls, isCoApplicant: boolean): keyof IApplicationUrlsDto => {
	return SigningUrlsMapping[urlName](isCoApplicant)
}